export const APPEND_HISTORY_ENTRIES = 'APPEND_HISTORY_ENTRIES';
export const GET_HISTORY_ENTRIES = 'GET_HISTORY_ENTRIES';
